
/*将根元素字号大小设置为：屏宽与图宽的比；  
由于chrom对10px以下的字不再缩小，而且手机屏  
都比较小，所以作为默认字体大小又乘了100，这样  
计算其他元素大小时，量出图上大小再除以100就可以了*/
function defaultfont() {
    var ymW = document.body.clientWidth;
    var ymH = document.body.clientHeight;
    // $('body').append('<p>' + ymW+'-' + ymH + '</p>')
    var sw = ymW > 750 ? 750 : ymW;
    var sh = ymH > 750 ? 750 : ymH;
    var pw = 750;
    var f = 100 * sw / pw;
    var fv = 100 * sh / pw;
    var html = document.documentElement
    if (ymW < ymH) {
        html.style.fontSize = f + "px"
        if (ymW > 640) {
            html.style.fontSize = "50px"
        }

    } else {
        html.style.fontSize = fv+"px"
        if (ymH > 640) {
            html.style.fontSize = "50px"
        }
    }
}
defaultfont();
window.onresize = function(){
    defaultfont();
}

/*之所以要延时100ms再调用这个函数是因为
如果不这样屏幕宽度加载会有误差*/
setTimeout(function() {
    defaultfont();
}, 100);



// WEBPACK FOOTER //
// ./src/rem.js